import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { GetLanguageString } from "../../helper/Components";
import {
  LoadingSpinner,
  convertToDateString,
} from "../../../constants/const";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { ApiFinance } from "../../config/finance/ApiFinance";
import { ApiFinance as ApiFinanceLocal } from "../ApiFinance";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";

const MarkazShare = ({ history }) => {
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));

  const [loading, setLoading] = useState({
    source: false,
    submit: false,
    calculate: false,
  });

  const [resolvedCategory, setResolvedCategory] = useState(null);
  const [resolvedAccount, setResolvedAccount] = useState(null);

  const [formData, setFormData] = useState({
    date: new Date(),
    amount: "",
    memo: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setLoading((prev) => ({ ...prev, source: true }));
    ApiFinance()
      .GetFinanceAccountCategoriesListByType("transfers")
      .then((res) => {
        const firstCategory = res.data?.[0];
        if (firstCategory) {
          setResolvedCategory(firstCategory);
          ApiFinance()
            .GetFinanceCategoryAccountsById(firstCategory.value)
            .then((resAcc) => {
              const markazShareAcc = resAcc.data?.find(
                (acc) =>
                  acc.label &&
                  acc.label.toLowerCase().includes("markaz share"),
              );
              if (markazShareAcc) {
                setResolvedAccount(markazShareAcc);
              } else {
                swal({
                  title: "Warning",
                  text: "Markaz Share account not found in the resolved category accounts.",
                  icon: "warning",
                  buttons: "OK",
                });
              }
              setLoading((prev) => ({ ...prev, source: false }));
            })
            .catch((err) => {
              console.error(err);
              setLoading((prev) => ({ ...prev, source: false }));
            });
        } else {
          setLoading((prev) => ({ ...prev, source: false }));
          swal({
            title: "Warning",
            text: "No transfers category found in the system.",
            icon: "warning",
            buttons: "OK",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading((prev) => ({ ...prev, source: false }));
      });
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const [calculatedAmount, setCalculatedAmount] = useState(0);

  useEffect(() => {
    if (!formData.date) return;

    setLoading((prev) => ({ ...prev, calculate: true }));
    const formattedDate = convertToDateString(formData.date);

    ApiFinanceLocal()
      .GetMarkazShareCalculatedAmount(loggedInUnitId, formattedDate)
      .then((res) => {
        const amount = res.data;
        setCalculatedAmount(amount);
        setFormData((prev) => ({ ...prev, amount: amount.toString() }));
        setLoading((prev) => ({ ...prev, calculate: false }));
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("funds_markaz_share_calculation_failed"));
        setLoading((prev) => ({ ...prev, calculate: false }));
      });
  }, [formData.date, loggedInUnitId, t]);

  const validate = () => {
    const temp = {};
    let isValid = true;

    if (!formData.date) {
      temp.date = t("common_field_required_error");
      isValid = false;
    }

    if (!formData.amount || formData.amount.toString().trim() === "") {
      temp.amount = t("common_field_required_error");
      isValid = false;
    } else {
      const parsedAmount = parseFloat(formData.amount);
      if (isNaN(parsedAmount) || parsedAmount <= 0) {
        temp.amount = t("amount_must_be_greater_than_zero");
        isValid = false;
      }
    }

    if (!resolvedAccount) {
      temp.account = "Resolved Account not found.";
      isValid = false;
    }

    setErrors(temp);
    return isValid;
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    if (!validate()) {
      return;
    }

    const selectedDate = formData.date;
    const lastDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
    lastDayOfMonth.setHours(12, 0, 0, 0);
    const enteredAmount = parseFloat(formData.amount);
    const calcAmount = parseFloat(calculatedAmount);
    const isRequest = enteredAmount < calcAmount;

    const executeSubmit = () => {
      const payload = {
        financeAccount: resolvedAccount,
        category: resolvedCategory,
        date: lastDayOfMonth,
        amount: enteredAmount,
        memo: formData.memo,
        unitId: loggedInUnitId,
        isRequest: isRequest,
      };

      setLoading((prev) => ({ ...prev, submit: true }));

      ApiFinanceLocal()
        .MarkazShareTransfer(payload)
        .then((res) => {
          const data = res.data;
          if (data?.statusCode === 200) {
            let msg = t("funds_markaz_share_transfer_added_successfully");
            if (data.message === "finance_markaz_share_requested") {
              msg = t("finance_markaz_share_requested");
            } else if (t(data.message) !== data.message) {
              msg = t(data.message);
            }
            swal({
              title: "Success",
              text: msg,
              icon: "success",
              buttons: "OK",
            }).then(() => {
              history.goBack();
            });
            return;
          }

          swal({
            title: "Error",
            text: data?.message || "Failed to add Markaz Share",
            icon: "error",
            buttons: "OK",
          });
          setLoading((prev) => ({ ...prev, submit: false }));
        })
        .catch((err) => {
          console.error(err);
          swal({
            title: "Error",
            text: "Unable to connect to server. Please try again.",
            icon: "error",
            buttons: "OK",
          });
          setLoading((prev) => ({ ...prev, submit: false }));
        });
    };

    if (isRequest) {
      swal({
        title: t("funds_markaz_share_request_confirm_title"),
        text: t("funds_markaz_share_request_confirm_text"),
        icon: "warning",
        buttons: [
          t("funds_markaz_share_request_confirm_btn_cancel"),
          t("funds_markaz_share_request_confirm_btn_proceed")
        ],
        className: GetSelectedLanguage() === "en" ? "" : "ur",
      }).then((proceed) => {
        if (proceed) {
          executeSubmit();
        }
      });
    } else {
      executeSubmit();
    }
  };

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      <div className="ibox">
        <div className="ibox-title d-flex justify-content-between align-items-center">
          <h5>{<GetLanguageString props="funds_markaz_share" />}</h5>
          <Button
            className={GetCustomStyles().btn_style}
            color="white"
            size="xs"
            onClick={() => history.goBack()}
          >
            <IoArrowBackSharp
              color="#18A689"
              size={15}
              style={{ marginRight: 5, marginBottom: 1 }}
            />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>

        <div className="ibox-content">
          {loading.source || loading.submit ? (
            LoadingSpinner()
          ) : (
            <Form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label className="col-form-label">
                      {<GetLanguageString props="funds_date" />}
                    </Label>
                    <DatePicker
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select month"
                      className="form-control no-drag"
                      selected={formData.date}
                      maxDate={new Date()}
                      onChange={(date) =>
                        handleChange("date", date ?? new Date())
                      }
                      showMonthYearPicker
                      dateFormat="MMMM yyyy"
                    />
                    {errors.date && <h4 className="text-error">{errors.date}</h4>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label className="col-form-label">
                      {<GetLanguageString props="funds_add_fund_amount" />}
                    </Label>
                    <Input
                      name="amount"
                      type="text"
                      value={formData.amount}
                      onChange={(e) => handleChange("amount", e.target.value)}
                      className="no-drag"
                      invalid={!!errors.amount}
                      disabled={loading.calculate}
                    />
                    {loading.calculate && (
                      <small className="text-muted">Calculating share...</small>
                    )}
                    {errors.amount && <h4 className="text-error no-drag">{errors.amount}</h4>}
                  </FormGroup>
                </Col>

                <Col md="4">
                  <FormGroup>
                    <Label className="col-form-label">
                      {<GetLanguageString props="transactions_memo" />}
                    </Label>
                    <Input
                      name="memo"
                      type="text"
                      value={formData.memo}
                      onChange={(e) => handleChange("memo", e.target.value)}
                      className="no-drag"
                      invalid={!!errors.memo}
                    />
                    {errors.memo && <h4 className="text-error no-drag">{errors.memo}</h4>}
                  </FormGroup>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md="9"></Col>
                <Col md="3" className="text-end">
                  <Button
                    type="submit"
                    color="primary"
                    disabled={loading.submit || loading.calculate || !resolvedAccount}
                  >
                    {<GetLanguageString props="funds_submit" />}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(MarkazShare);
